/* ============================================================
   KuKirin Romobili — theme interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---- Sticky header shadow on scroll ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile nav toggle ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) {
        var open = nav.hasAttribute('hidden');
        if (open) { nav.removeAttribute('hidden'); } else { nav.setAttribute('hidden', ''); }
        toggle.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
      }
    }
    var close = e.target.closest('[data-nav-close]');
    if (close) {
      var n = document.querySelector('[data-mobile-nav]');
      if (n) { n.setAttribute('hidden', ''); document.body.style.overflow = ''; }
    }
  });

  /* ---- Quantity stepper ---- */
  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-qty-inc]');
    var dec = e.target.closest('[data-qty-dec]');
    if (inc || dec) {
      var wrap = (inc || dec).closest('.qty');
      var input = wrap.querySelector('input');
      var v = parseInt(input.value || '1', 10);
      v = inc ? v + 1 : Math.max(1, v - 1);
      input.value = v;
    }
  });

  /* ---- Quick add to cart (product cards) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-quick-add');
    if (!id || btn.dataset.loading) return;
    btn.dataset.loading = '1';
    var original = btn.textContent;
    btn.textContent = 'Dodajem…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.CartDrawer) { window.CartDrawer.open(); }
        btn.textContent = '✓ Dodano';
        setTimeout(function () { btn.textContent = original; delete btn.dataset.loading; }, 1600);
      })
      .catch(function () {
        btn.textContent = original; delete btn.dataset.loading;
        window.location.href = '/cart';
      });
  });

  /* ---- Reveal on scroll ---- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- Force-autoplay muted videos (esp. showcase section) ---- */
  var vids = document.querySelectorAll('video[autoplay]');
  if (vids.length) {
    var tryPlay = function (v) {
      v.muted = true;            // some browsers require the muted property, not just the attribute
      var p = v.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    };
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { tryPlay(entry.target); }
          else { entry.target.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { vio.observe(v); tryPlay(v); });
    } else {
      vids.forEach(tryPlay);
    }
  }

  /* ---- Count-up numbers on the stat band (first time in view) ---- */
  var statband = document.querySelector('.statband');
  if (statband) {
    var animateStats = function () {
      var nums = statband.querySelectorAll('.s strong');
      nums.forEach(function (el) {
        var target = el.textContent.trim();
        var match = target.match(/[\d][\d\s.,]*\d|\d/); // first numeric run
        if (!match) return;
        var token = match[0];
        var prefix = target.slice(0, match.index);
        var suffix = target.slice(match.index + token.length);
        var usedSpace = /\s/.test(token);
        var clean = token.replace(/\s/g, '');
        var decimals = (clean.split('.')[1] || '').length;
        var end = parseFloat(clean.replace(',', '.'));
        if (isNaN(end)) return;
        var format = function (val) {
          var s = val.toFixed(decimals);
          if (usedSpace) {
            var parts = s.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            s = parts.join('.');
          }
          return prefix + s + suffix;
        };
        var dur = 1500, start = null;
        var step = function (ts) {
          if (start === null) start = ts;
          var t = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
          el.textContent = format(end * eased);
          if (t < 1) { requestAnimationFrame(step); }
          else { el.textContent = target; }
        };
        el.textContent = format(0);
        requestAnimationFrame(step);
      });
    };
    if ('IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { animateStats(); sio.disconnect(); }
        });
      }, { threshold: 0.4 });
      sio.observe(statband);
    } else {
      animateStats();
    }
  }

  /* ---- Category catalogs (click a category → open its product grid) ---- */
  (function () {
    var section = document.querySelector('[data-catalog-section]');
    if (!section) return;

    var closePanel = function (panel) {
      if (!panel) return;
      panel.setAttribute('hidden', '');
      var trigger = section.querySelector('[data-cat-trigger="' + panel.getAttribute('data-cat-panel') + '"]');
      if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.classList.remove('is-active'); }
    };

    var openPanel = function (panel, trigger) {
      section.querySelectorAll('.cat-catalog').forEach(closePanel);
      panel.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('is-active');
      // ensure product cards (which use .reveal) become visible immediately
      panel.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      var top = panel.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    };

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cat-trigger]');
      if (trigger) {
        var key = trigger.getAttribute('data-cat-trigger');
        var panel = section.querySelector('[data-cat-panel="' + key + '"]');
        if (!panel) return;
        if (trigger.getAttribute('aria-expanded') === 'true') { closePanel(panel); }
        else { openPanel(panel, trigger); }
        return;
      }
      var closeBtn = e.target.closest('[data-cat-close]');
      if (closeBtn) {
        var p = closeBtn.closest('.cat-catalog');
        closePanel(p);
        var t = section.querySelector('[data-cat-trigger="' + p.getAttribute('data-cat-panel') + '"]');
        if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }
    });
  })();

  /* ---- Horizontal product rows: arrow buttons + mouse drag-to-scroll ---- */
  document.querySelectorAll('[data-product-row]').forEach(function (row) {
    var track = row.querySelector('[data-row-track]');
    var prev = row.querySelector('[data-row-prev]');
    var next = row.querySelector('[data-row-next]');
    if (!track) return;

    var step = function () {
      var card = track.querySelector('.product-card');
      var gap = 18;
      return card ? (card.offsetWidth + gap) * 2 : track.clientWidth * 0.8;
    };
    var updateArrows = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max;
      if (prev) prev.hidden = atStart;
      if (next) next.hidden = atEnd;
      // only fade an edge when there's content hidden beyond it
      track.style.setProperty('--fade-l', atStart ? '0px' : 'var(--fade-w)');
      track.style.setProperty('--fade-r', atEnd ? '0px' : 'var(--fade-w)');
    };

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    /* mouse drag-to-scroll (touch keeps native scrolling).
       Capture only AFTER a real drag starts, so plain clicks still reach card links. */
    var down = false, startX = 0, startScroll = 0, moved = false, captured = false, pid = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; captured = false; pid = e.pointerId;
      startX = e.clientX; startScroll = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(pid); captured = true; } catch (_) {}
      }
      if (moved) { track.scrollLeft = startScroll - dx; e.preventDefault(); }
    });
    var end = function () {
      if (!down) return;
      down = false;
      if (captured) { try { track.releasePointerCapture(pid); } catch (_) {} captured = false; }
      track.classList.remove('is-dragging');
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    /* swallow the click that immediately follows a drag so cards don't navigate */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
      moved = false;
    }, true);
  });

  /* ---- Cart drawer (slide-in from right; opens on add & on cart click) ---- */
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var closeTimer = null;

    var money = function (c) {
      var n = (Math.round(c) / 100).toFixed(2).split('.');
      n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€' + n[0] + ',' + n[1];
    };
    var setCount = function (n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
    };
    var thumb = function (src) {
      if (!src) return '';
      return src.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
    };
    var render = function (cart) {
      setCount(cart.item_count);
      if (!cart.item_count) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>Vaša košarica je prazna.</p>' +
          '<a class="btn btn--ghost" href="/collections/all" data-cart-close>Istraži modele</a></div>';
        foot.hidden = true;
        return;
      }
      var html = '';
      cart.items.forEach(function (it) {
        var img = thumb(it.image);
        html += '<div class="cd-item" data-key="' + it.key + '">' +
          (img ? '<img class="cd-item__img" src="' + img + '" alt="" width="72" height="72">' : '<span class="cd-item__img"></span>') +
          '<div class="cd-item__info">' +
            '<a class="cd-item__title" href="' + it.url + '">' + it.product_title + '</a>' +
            '<span class="cd-item__unit">' + money(it.final_price) + ' / kom</span>' +
            '<div class="cd-item__bottom">' +
              '<div class="cd-qty"><button type="button" data-cd-dec aria-label="Manje">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-cd-inc aria-label="Više">+</button></div>' +
              '<button type="button" class="cd-item__remove" data-cd-remove>Ukloni</button>' +
            '</div>' +
          '</div>' +
          '<span class="cd-item__line">' + money(it.final_line_price) + '</span>' +
        '</div>';
      });
      body.innerHTML = html;
      totalEl.textContent = money(cart.total_price);
      foot.hidden = false;
    };
    var refresh = function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c); return c; });
    };
    var open = function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      refresh();
    };
    var close = function () {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      closeTimer = setTimeout(function () { drawer.hidden = true; }, 380);
    };
    var change = function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
    };

    window.CartDrawer = { open: open, close: close, refresh: refresh };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    body.addEventListener('click', function (e) {
      var row = e.target.closest('.cd-item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var span = row.querySelector('.cd-qty span');
      var cur = parseInt(span ? span.textContent : '1', 10);
      if (e.target.closest('[data-cd-inc]')) change(key, cur + 1);
      else if (e.target.closest('[data-cd-dec]')) change(key, Math.max(0, cur - 1));
      else if (e.target.closest('[data-cd-remove]')) change(key, 0);
    });
  })();

  /* ---- Intercept product-page add-to-cart → add via fetch + open drawer ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Dodajem…'; btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.CartDrawer) { window.CartDrawer.open(); }
        if (btn) { btn.textContent = '✓ Dodano'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600); }
      })
      .catch(function () { form.submit(); });
  });

  /* ---- Search panel (drops from top, live predictive results) ---- */
  (function () {
    var sp = document.querySelector('[data-search]');
    if (!sp) return;
    var input = sp.querySelector('[data-search-input]');
    var results = sp.querySelector('[data-search-results]');
    var timer = null, closeT = null;

    var money = function (v) {
      var n = parseFloat(v);
      if (isNaN(n)) return '';
      var s = n.toFixed(2).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€' + s[0] + ',' + s[1];
    };
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
    var hint = function (t) { results.innerHTML = '<p class="search-panel__hint">' + t + '</p>'; };

    var open = function () {
      if (closeT) { clearTimeout(closeT); closeT = null; }
      sp.hidden = false;
      requestAnimationFrame(function () { sp.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 140);
      if (!results.innerHTML) hint('Upiši naziv modela — npr. G2, G4 Max, A1…');
    };
    var close = function () {
      sp.classList.remove('is-open');
      document.body.style.overflow = '';
      closeT = setTimeout(function () { sp.hidden = true; }, 380);
    };

    var doSearch = function (q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6',
        { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = ((((d || {}).resources || {}).results || {}).products) || [];
          if (!items.length) { results.innerHTML = '<p class="search-panel__empty">Nema rezultata za “' + esc(q) + '”.</p>'; return; }
          results.innerHTML = items.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            var cmp = (parseFloat(p.compare_at_price_min) > parseFloat(p.price))
              ? '<span class="search-res__compare">' + money(p.compare_at_price_min) + '</span>' : '';
            return '<a class="search-res" href="' + p.url + '">' +
              (img ? '<img class="search-res__img" src="' + img + '" alt="" width="56" height="56">' : '<span class="search-res__img"></span>') +
              '<span class="search-res__title">' + esc(p.title) + '</span>' +
              '<span class="search-res__price">' + money(p.price) + '</span>' + cmp +
            '</a>';
          }).join('');
        })
        .catch(function () { results.innerHTML = ''; });
    };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sp.classList.contains('is-open')) close();
    });
    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { hint('Upiši barem 2 znaka…'); return; }
        timer = setTimeout(function () { doSearch(q); }, 220);
      });
    }
  })();
})();
